export default __webpack_public_path__ + "static/media/sip-notification.1ab05d44.svg";